import { render, staticRenderFns } from "./borrowerTasks.vue?vue&type=template&id=ee7cd7d0&scoped=true&"
import script from "./borrowerTasks.vue?vue&type=script&lang=js&"
export * from "./borrowerTasks.vue?vue&type=script&lang=js&"
import style0 from "./borrowerTasks.vue?vue&type=style&index=0&id=ee7cd7d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee7cd7d0",
  null
  
)

export default component.exports